import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

export function ProcessInterviewMenuItem({ onSelect }: { onSelect: () => void }) {
    return <DropdownMenuItem onClick={onSelect}>Process interview</DropdownMenuItem>
}
